export default {
  'menu.projectManage': '项目管理',
  'menu.configurationCenter': '配置字典',
  'menu.FormulaConfig': '公式配置',
  'menu.configurationCenter.transportation': '人员运输方式',
  'menu.configurationCenter.typesForEquipment': '设备用燃料类型',
  'menu.configurationCenter.horsepower': '代表马力',
  'menu.configurationCenter.materials': '材料表',
  'menu.configurationCenter.fuelEfficiency': '燃料效率值',
  'menu.configurationCenter.wasteTreatmentFacility': '废物处理设施',
  'menu.configurationCenter.waterSource': '水源',
  'menu.configurationCenter.laboratoryAnalysis': '实验室分析',
  'menu.configurationCenter.electric': '电力结构',
  'menu.configurationCenter.settingTable': '自定义配置表',
  'menu.configurationCenter.conversionFactor': '转换因子',
  'menu.configurationCenter.unit': '单位',
  'menu.listSolutions': '解决方案列表',
  'menu.listSolutions.fixSolutions': '修复解决方案',
  'menu.listSolutions.activityDataSummary': '活动数据汇总',
  'menu.listSolutions.activityDataSummary.offSiteRenewableEnergy': '现场可再生能源',
  'menu.listSolutions.activityDataSummary.siteConventionalEnergy': '现场常规能源',
  'menu.listSolutions.activityDataSummary.otherSiteContribution': '其他现场贡献',
  'menu.listSolutions.activityDataSummary.sitePowerGeneration': '现场发电',
  'menu.listSolutions.activityDataSummary.transportFuelUsageDetails': '运输燃料使用明细',
  'menu.listSolutions.activityDataSummary.onSiteTransportationTotal': '场内运输总量',
  'menu.listSolutions.activityDataSummary.footprintBuildingMaterials': '有足迹的建筑材料',
  'menu.listSolutions.activityDataSummary.footprintProcessingMaterials': '有足迹处理材料/化学品',
  'menu.listSolutions.activityDataSummary.materialTypeSummary': '材料类型汇总',
  'menu.listSolutions.activityDataSummary.fuelProcessing': '燃料加工',
  'menu.listSolutions.activityDataSummary.waterUsage': '用水',
  'menu.listSolutions.activityDataSummary.wasteRecycling': '废物回收处理',
  'menu.listSolutions.activityDataSummary.solidWasteTotal': '固体废物总量',
  'menu.listSolutions.activityDataSummary.laboratoryServices': '实验室服务',
  'menu.listSolutions.activityDataSummary.powerResourceExtraction': '电力资源开采',
  
  'menu.listSolutions.carbonFootprintSummary': '碳足迹汇总',
  'menu.listSolutions.carbonFootprintSummary.offSiteFootprint': '现场足迹(范围1)',
  'menu.listSolutions.carbonFootprintSummary.powerGenerationFootprint': '发电碳足迹(范围2)',
  'menu.listSolutions.carbonFootprintSummary.transportationFootprint': '运输碳足迹(范围3)',
  'menu.listSolutions.carbonFootprintSummary.offSiteFootprint3B1': '场外足迹(范围3B)',
  'menu.listSolutions.environmentalFootprintSummary': '环境足迹汇总表',
  'menu.listSolutions.energyAtmosphericPollutantSummary':
    '能源与大气污染物汇总',
  'menu.listSolutions.carbonFootprintAnalysis': '碳足迹分析',
  'menu.fixSolutionsDetail': '修复解决方案详情',
  'menu.fixSolutionsDetail.EnvironmentalData': '环境活动数据',
  'menu.fixSolutionsDetail.EnvironmentalData.perTransportation': '人员交通',
  'menu.fixSolutionsDetail.EnvironmentalData.equipmentUseAndTransport':
    '现场设备使用和运输',
  'menu.fixSolutionsDetail.EnvironmentalData.onSiteElectricity': '现场电力使用',
  'menu.fixSolutionsDetail.EnvironmentalData.onSiteNaturalGas':
    '现场天然气使用',
  'menu.fixSolutionsDetail.EnvironmentalData.onSiteIncineration':
    '现场焚烧垃圾填埋气',
  'menu.fixSolutionsDetail.EnvironmentalData.waterUsage': '用水类型',
  'menu.fixSolutionsDetail.EnvironmentalData.materialUsageAndTransport':
    '材料使用和运输',
  'menu.fixSolutionsDetail.EnvironmentalData.wasteTreatmentAndTransport':
    '废物处理和运输',
  'menu.fixSolutionsDetail.EnvironmentalData.custom': '自定义',
  'menu.fixSolutionsDetail.EnvironmentalData.offSiteLaboratoryAnalysis':
    '非现场实验室分析',
  'menu.fixSolutionsDetail.environmentalActivityCalculation': '环境活动计算',
  'menu.fixSolutionsDetail.environmentalActivityCalculation.onSiteRenewableEnergy':
    '现场可再生能源',
  'menu.fixSolutionsDetail.environmentalActivityCalculation.onSiteConventionalEnergy':
    '现场常规能源',
  'menu.fixSolutionsDetail.environmentalActivityCalculation.otherOnSiteContributions':
    '其他现场贡献',
  'menu.fixSolutionsDetail.environmentalActivityCalculation.onSitePowerGeneration':
    '现场发电',
  'menu.fixSolutionsDetail.environmentalActivityCalculation.transportFuelUsageDetails':
    '运输燃料使用明细',
  'menu.fixSolutionsDetail.environmentalActivityCalculation.onSiteTransportationTotal':
    '场内运输总量',
  'menu.fixSolutionsDetail.environmentalActivityCalculation.footprintBuildingMaterials':
    '有足迹的建筑材料',
  'menu.fixSolutionsDetail.environmentalActivityCalculation.footprintProcessingMaterialsChemicals':
    '有足迹的处理材料和化学',
  'menu.fixSolutionsDetail.environmentalActivityCalculation.materialTypeSummary':
    '材料类型汇总',
  'menu.fixSolutionsDetail.environmentalActivityCalculation.fuelProcessing':
    '燃料加工',
  'menu.fixSolutionsDetail.environmentalActivityCalculation.waterUsage': '用水',
  'menu.fixSolutionsDetail.environmentalActivityCalculation.wasteRecyclingTreatment':
    '废物回收处理',
  'menu.fixSolutionsDetail.environmentalActivityCalculation.solidWasteTotal':
    '固体废物总量',
  'menu.fixSolutionsDetail.environmentalActivityCalculation.laboratoryServices':
    '实验室服务',
  'menu.fixSolutionsDetail.environmentalActivityCalculation.electronicResourceExtraction':
    '电力资源开采',
  'menu.fixSolutionsDetail.carbonFootprintCalculation': '碳足迹计算',
  'menu.fixSolutionsDetail.carbonFootprintCalculation.onSiteFootprint':
    '现场足迹（范围1）',
  'menu.fixSolutionsDetail.carbonFootprintCalculation.powerGenerationFootprint':
    '发电碳足迹（范围2）',
  'menu.fixSolutionsDetail.carbonFootprintCalculation.transportFootprint':
    '运输足迹（范围3a）',
  'menu.fixSolutionsDetail.carbonFootprintCalculation.offSiteFootprint1':
    '场外足迹（范围3b）',
  'menu.fixSolutionsDetail.carbonFootprintCalculation.transportFuelUsageDetails':
    '运输燃料使用明细',
  'menu.fixSolutionsDetail.carbonFootprintCalculation.offSiteFootprint2':
    '场外足迹（范围3b-2）',
  'menu.fixSolutionsDetail.carbonFootprintCalculation.offSiteFootprint3':
    '场外足迹（范围3b-3）',
  'menu.fixSolutionsDetail.carbonFootprintCalculation.midTotal': '中间总计',
  'menu.fixSolutionsDetail.energyGas': '能源与大气污染物',
  'menu.fixSolutionsDetail.energyGas.energyGasTotal': '能源与大气污染物汇总',
'menu.fixSolutionsDetail.energyGas.renewableEnergyUseItem':
    '自愿性可再生能源使用物',
      'menu.fixSolutionsDetail.energyGasTotal': '能源与大气污染物汇总',
'menu.fixSolutionsDetail.renewableEnergyUseItem':
    '自愿性可再生能源使用物',
    'menu.fixSolutionsDetail.energyGasFootprints': '现场足迹汇总',
  'menu.summaryData': '活动数据汇总',
  'menu.PersonalCenter': '个人中心',
  'menu.OrganizationManagement': '组织管理',
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
};
